function timelineHelper(data, filter) {
  if (data.length < 1)
    return [
      {
        month: 'No data available - please add published URLS',
        lineData: 0,
        lineDataLabel: '$0',
        barData: 0
      }
    ];
  switch (filter) {
    case 'Last 12 Months':
      return data.slice(2);

    case 'Last 6 Months':
      return data.slice(8);

    case 'Last 3 Months':
      return data.slice(11);

    default:
      return data;
  }
}

function paramTimeHelper(timeline) {
  switch (timeline) {
    case 'Last 12 Months':
      return 2;

    case 'Last 6 Months':
      return 8;

    case 'Last 3 Months':
      return 11;

    default:
      return 0;
  }
}

export { timelineHelper, paramTimeHelper };



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/timelineHelpers.js